import env from '../../../config/env';
import { isEqualTo, isObject, isNull } from '../../../helpers/helpers';
import filter from '../../../helpers/filters';
import CategoriaBreadcrumb from '../../../graphql/revista/queries/BreadcrumbCategoria.gql';
import NoticiaBreadcrumb from '../../../graphql/revista/queries/BreadcrumbNoticia.gql';

const BREADCRUMB_CHANGE = 'BREADCRUMB_CHANGE';
const BREADCRUMB_NAME = 'BREADCRUMB_NAME';

export default {
  namespaced: true,
  state: {
    name: null,
    home: {
      href: '/',
      name: 'Home',
    },
    breadcrumb: [],
  },
  getters: {
    getBreadcrumb: state => state.breadcrumb,
    getTitle: state => state.name,
  },
  mutations: {
    [BREADCRUMB_CHANGE](state, value) {
      state.breadcrumb = value;
    },
    [BREADCRUMB_NAME](state, name) {
      state.name = name;
    },
  },
  actions: {
    setTitleBreadcrumb({ commit }, { name }) {
      commit(BREADCRUMB_NAME, name);
    },
    setBreadcrumb({ state, commit, rootGetters }, { name, params, path }) {
      // Reset breadcrumb
      state.breadcrumb = [];
      // Categorias
      if (isEqualTo(name, 'categoria')) {
        env.apolloRevista
          .query({
            query: CategoriaBreadcrumb,
            variables: {
              modulo: env.revista.modulo,
              slug: params.categoria,
            },
          })
          .then(({ data: { breadcrumb: { data } } }) => {
            const resp = data;
            const breadcrumb = [];
            breadcrumb.push(state.home);
            resp.map(r => {
              if (isObject(r.principal) && !isNull(r.principal)) {
                breadcrumb.push(r.principal);
              }
              breadcrumb.push({ name: r.name, href: r.href });
            });
            commit(BREADCRUMB_CHANGE, breadcrumb);
          });
      }
      // Noticias (POST)
      else if (isEqualTo(name, 'post')) {
        const uf = rootGetters['user/uf'];
        env.apolloRevista
          .query({
            query: NoticiaBreadcrumb,
            variables: {
              modulo: env.revista.modulo,
              canal: env.revista.canal,
              slug: params.noticia,
              uf: [uf],
            },
          })
          .then(({ data: { breadcrumb: { data } } }) => {
            const resp = data;
            const breadcrumb = [];
            breadcrumb.push(state.home);
            resp.map(r => {
              if (isObject(r.categoria) && !isNull(r.categoria)) {
                if (isObject(r.categoria.principal) && !isNull(r.categoria.principal)) {
                  breadcrumb.push({
                    name: r.categoria.principal.name,
                    href: `/categoria/${r.categoria.principal.href}`,
                  });
                }
                breadcrumb.push({
                  name: r.categoria.name,
                  href: `/categoria/${r.categoria.href}`,
                });
              }
              breadcrumb.push({ name: filter.shortWords(r.name, 30), href: r.href });
            });
            commit(BREADCRUMB_CHANGE, breadcrumb);
          });
      }
      // NOTIFICACAO
      else if (isEqualTo(name, 'notificacao')) {
        const breadcrumb = [];
        breadcrumb.push(state.home);
        breadcrumb.push({
          name: 'Notificação',
          href: '/notificacao',
        });
        commit(BREADCRUMB_CHANGE, breadcrumb);
      } else if (isEqualTo(name, 'ranking-lojas')) {
        const breadcrumb = [];
        breadcrumb.push(state.home);
        breadcrumb.push({
          name: 'Ranking de Lojas',
          href: '/ranking-lojas',
        });
        commit(BREADCRUMB_CHANGE, breadcrumb);
      }
    },
  },
};
